import { styled } from '@mui/material'

export const DialogContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'start',
  rowGap: '16px',
  padding: '24px',
  background: '#ECFEFF',
})

export const ButtonContainer = styled('div')({
  display: 'flex',
  alignContent: 'center',
  columnGap: '16px',
})
